import { gql } from '@apollo/client';
import { DocumentNode } from 'graphql';

export const fragments: { [key: string]: DocumentNode } = {
  quoteData: gql`
    fragment QuoteDataFields on QuoteData {
      GpData {
        TargetGp
        FireRatingGp
      }
      GeneralData {
        QuoteReference {
          Quote
          Revision
          Option
        }
        QuoteType
        QuoteDate
        Notes
        ExpectedInstallationDate
        DistributorName
        ContactName
        Reference
        BuildingStandard
        IsFireRated
        CostTransport
        AreaCode
        CostInstallation
        CostAncillaries
        ExWorks
        CostInstallationAsExtraOver
        ShowAncillaries
        AllowStaircaseInsideFloor
      }
      FloorData {
        GridData {
          BaySpacing
          BeamDirection
          NotifyIfOtherBeamDirectionCheaper
          YDim
          XDim
          XBays
          YBays
          XBayDistances {
            Auto
            Value
          }
          YBayDistances {
            Auto
            Value
          }
          IsMinBasePlateWidthMainAuto
          IsMinBasePlateWidthEdgeAuto
          MinBasePlateWidthMain
          MinBasePlateWidthEdge
        }
        DesignData {
          UcColumnsOnly
          UseStubJoists
          MaxFloorDepth
          UseAngles
          AdaptiveDesignProcedures
          LimitStrutSections
          StrutDistance
          BracingType
        }
        BraceData {
          BraceArguments {
            TierNumber
            Type
            Orientation
            StartX
            StartY
            EndX
            EndY
          }
        }
        DeckingData {
          IsDeckingRequired
          DeckingCentres
          DeckingSection
        }
        TiersData {
          TierCount
          CopyTierData
          TierData {
            Height
            LoadType
            LiveLoad
            DeadLoad
            ServiceLoad
            BeamDeflection
            JoistDeflection
            MinJoistThickness
            Depth
            Area
            CutoutData {
              Hash
              X
              Y
              XDim
              YDim
              RecalculateEdgeProtection
            }
          }
          HeightType
        }
      }
      TransportData {
        TransportAuto
        TransportLorries
        AreaBandCost
        LoadLorryCost
      }
      InstallationData {
        IsInstallationAuto
        ClearBuildJob
        Area
        TeamSize
        NormalTeamCost
        LargeTeamCost
        Days
        Cost
        Netting
        TotalCost
        Stairs
        Handrail
        Locked
      }
      FireRatingData {
        OverrideMinColumnThickness
        CostFireRating
        CostColumnCasings
        ColumnCasingFinish
        CostCeilings
        CeilingGridSize
        CostFascia
        FasciaLengthAuto
        FasciaLength
      }
      AncillaryData {
        CalcPlant
        LongestBeamLength
        LongestJoistLength
        AncillaryArguments {
          Ancillary
          IsExtraOver
          Height
          Length
          Quantity
          AutoCalculateHeight
          Positions {
            TierNumber
            X
            Y
            Width
            Depth
            EndX
            EndY
            Direction
            SnappedEdge
            DescentDirection
            TurnDirection
            LandingDepth
          }
          AutoCalculateLength
          IsAutoIncluded
          RecalculateOnCutoutChange
          Runs {
            TierNumber
            Edge
            StartX
            StartY
            EndX
            EndY
            Length
            Posts {
              X
              Y
            }
          }
        }
        OverrideNoGeneralAccessStaircase
        OverrideNoEdgeProtection
      }
      TransformData {
        TransformType
        ComponentId
        TierNumber
        XPosition
        YPosition
        Index
      }
      UserSettings {
        UserDefinedInstallation
      }
    }
  `,
};

/** What a new quote starts as, built by the API from the load type and the costs. */
export const getDefaultQuoteDataQuery: DocumentNode = gql`
  query defaultQuoteData($quoteType: Int!) {
    defaultQuoteData(quoteType: $quoteType) {
      ...QuoteDataFields
    }
  }
  ${fragments.quoteData}
`;
